import React, { useState } from 'react';
import i18n from '../../i18n';
import { Page, Document} from 'react-pdf';

import {withStyles} from "@material-ui/core/styles/index";

class ProtocolsDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTab: 0,
        };
    }

    render() {
        const {person, classes} = this.props;

        // const [numPages, setNumPages] = useState(null);
        // const [pageNumber, setPageNumber] = useState(1);
        const numPages = null,
        setNumPages = null,
            pageNumber = 1,
            setPageNumber = 1;
        //
        function onDocumentLoadSuccess({ numPages }) {
            setNumPages((numPages));
        }

        return (
            <React.Fragment>
                 <Document file="testFile.pdf">
                     <Page pageNumber={pageNumber} />
                 </Document>
                 <p>Page {pageNumber} of {numPages}</p>
             </React.Fragment>
        )
    }
}

const styles = {
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
};

export default withStyles(styles)(ProtocolsDetails);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/ProtocolsDetails.js